// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title,
.subtitle_h1,
.subtitle_h1_centered {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  text-align: start;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 100%;
}

.title-dwin-state-value-input {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 100%;
}

.title.multi-line {
  background-color: #f0f0f0;
  color: #333;
  text-align: start;
}

.subtitle {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  padding-top: var(--d-spacing-half);
}

.subtitle_h1-dwin-state-value-input {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  padding-top: var(--d-spacing-half);
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 100%;
}

.subtitle-dwin-state-value-input {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding-left: var(--d-spacing-single);
  padding-right: var(--d-spacing-single);
}

.chevron-back {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  display: flex;
  height: 25px;
  width: 25px;
  justify-content: center;
  align-items: center;
}

ion-icon.close-x-icon {
  margin-top: 5px;
}

.back-button {
  height: 23px;
  width: 28px;
  padding-right: var(--d-spacing-single);
}

.header-buttons-slot,
.cancel-project-ellipsis,
.dwin-header-buttons-left,
.dwin-header-buttons-right {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.dwin-header-buttons-left,
.closing-x-button-left {
  justify-content: flex-start;
  align-items: flex-start;
}

.dwin-header-buttons-right {
  justify-content: flex-end;
  padding: 0;
  margin: 0;
}

.reference-bar-buttons-container {
  justify-content: flex-end;
}

.closing-x-container {
  justify-content: flex-start;
  padding-right: 50px;
}

ion-row {
  display: flex;
  flex-wrap: nowrap;
}

ion-header {
  margin: 0 !important;
  padding: 0;
  background-color: white;
}

ion-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

ion-col.hidden {
  display: none;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
}

title.hidden {
  display: none;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
}

.custom-back-button-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 0px;
}

.center {
  text-align: center;
}

.alignment-start {
  text-align: start;
}

#dwin-header-grid {
  padding: var(--d-spacing-half) 0;
}

.left-grid-col {
  padding-left: var(--d-spacing-single);
  padding-top: 0;
  margin-top: 0;
  padding-bottom: 0;
}

.right-grid-col {
  padding-right: var(--d-spacing-single);
  padding-top: 0;
  margin-top: 0;
  padding-bottom: 0;
}

.header-progressbar {
  padding-top: 0;
  padding-bottom: 0;
  padding-left: var(--d-spacing-double);
  padding-right: var(--d-spacing-double);
}

.header-row {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 var(--d-spacing-single);
  flex-wrap: wrap;
}

.title-container {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
}

.title {
  white-space: normal;
  word-break: break-word;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/common/components/dwin-header/dwin-header.component.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAEA;;;ECDI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDEA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,4BAAA;EACA,WAAA;AAEJ;;AACA;ECdI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDaA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,4BAAA;EACA,WAAA;AAKJ;;AAFA;EACI,yBAAA;EACA,WAAA;EACA,iBAAA;AAKJ;;AAFA;ECxBI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDuBA,kCAAA;AAQJ;;AALA;ECpCI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDmCA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,4BAAA;EACA,WAAA;AAWJ;;AARA;ECzCI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDwCA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,sCAAA;AAcJ;;AAXA;ECzDI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDwDA,aAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AAiBJ;;AAdA;EACI,eAAA;AAiBJ;;AAdA;EACI,YAAA;EACA,WAAA;EACA,sCAAA;AAiBJ;;AAdA;;;;EAII,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAiBJ;;AAdA;;EAEI,2BAAA;EACA,uBAAA;AAiBJ;;AAdA;EACI,yBAAA;EACA,UAAA;EACA,SAAA;AAiBJ;;AAdA;EACI,yBAAA;AAiBJ;;AAdA;EACI,2BAAA;EACA,mBAAA;AAiBJ;;AAdA;EACI,aAAA;EACA,iBAAA;AAiBJ;;AAdA;EACI,oBAAA;EACA,UAAA;EACA,uBAAA;AAiBJ;;AAdA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AAiBJ;;AAdA;EACI,aAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AAiBJ;;AAdA;EACI,aAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AAiBJ;;AAdA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;AAiBJ;;AAdA;EACI,kBAAA;AAiBJ;;AAdA;EACI,iBAAA;AAiBJ;;AAdA;EACI,gCAAA;AAiBJ;;AAdA;EACI,qCAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AAiBJ;;AAdA;EACI,sCAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AAiBJ;;AAdA;EACI,cAAA;EACA,iBAAA;EACA,qCAAA;EACA,sCAAA;AAiBJ;;AAdA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kCAAA;EACA,eAAA;AAiBJ;;AAdA;EACI,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAiBJ;;AAdA;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;AAiBJ","sourcesContent":["@import 'src/mixins.scss';\n\n.title,\n.subtitle_h1,\n.subtitle_h1_centered {\n    @include h1-style;\n    text-align: start;\n    overflow: hidden;\n    display: -webkit-box;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    width: 100%;\n}\n\n.title-dwin-state-value-input {\n    @include h1-style;\n    text-align: center;\n    overflow: hidden;\n    display: -webkit-box;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    width: 100%;\n}\n\n.title.multi-line {\n    background-color: #f0f0f0;\n    color: #333;\n    text-align: start;\n}\n\n.subtitle {\n    @include p1-style;\n    padding-top: var(--d-spacing-half);\n}\n\n.subtitle_h1-dwin-state-value-input {\n    @include h1-style;\n    padding-top: var(--d-spacing-half);\n    text-align: center;\n    overflow: hidden;\n    display: -webkit-box;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    width: 100%;\n}\n\n.subtitle-dwin-state-value-input {\n    @include p1-style;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    padding-left: var(--d-spacing-single);\n    padding-right: var(--d-spacing-single);\n}\n\n.chevron-back {\n    @include h1-style;\n    display: flex;\n    height: 25px;\n    width: 25px;\n    justify-content: center;\n    align-items: center;\n}\n\nion-icon.close-x-icon {\n    margin-top: 5px;\n}\n\n.back-button {\n    height: 23px;\n    width: 28px;\n    padding-right: var(--d-spacing-single);\n}\n\n.header-buttons-slot,\n.cancel-project-ellipsis,\n.dwin-header-buttons-left,\n.dwin-header-buttons-right {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.dwin-header-buttons-left,\n.closing-x-button-left {\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n\n.dwin-header-buttons-right {\n    justify-content: flex-end;\n    padding: 0;\n    margin: 0;\n}\n\n.reference-bar-buttons-container {\n    justify-content: flex-end;\n}\n\n.closing-x-container {\n    justify-content: flex-start;\n    padding-right: 50px;\n}\n\nion-row {\n    display: flex;\n    flex-wrap: nowrap;\n}\n\nion-header {\n    margin: 0 !important;\n    padding: 0;\n    background-color: white;\n}\n\nion-col {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n}\n\nion-col.hidden {\n    display: none;\n    width: 0;\n    height: 0;\n    padding: 0;\n    margin: 0;\n}\n\ntitle.hidden {\n    display: none;\n    width: 0;\n    height: 0;\n    padding: 0;\n    margin: 0;\n}\n\n.custom-back-button-container {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 0px;\n}\n\n.center {\n    text-align: center;\n}\n\n.alignment-start {\n    text-align: start;\n}\n\n#dwin-header-grid {\n    padding: var(--d-spacing-half) 0;\n}\n\n.left-grid-col {\n    padding-left: var(--d-spacing-single);\n    padding-top: 0;\n    margin-top: 0;\n    padding-bottom: 0;\n}\n\n.right-grid-col {\n    padding-right: var(--d-spacing-single);\n    padding-top: 0;\n    margin-top: 0;\n    padding-bottom: 0;\n}\n\n.header-progressbar {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: var(--d-spacing-double);\n    padding-right: var(--d-spacing-double);\n}\n\n.header-row {\n    display: flex;\n    position: relative;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 0 var(--d-spacing-single);\n    flex-wrap: wrap;\n}\n\n.title-container {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    top: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 80%;\n}\n\n.title {\n    white-space: normal;\n    word-break: break-word;\n    text-align: center;\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
